import UserEligibilityForm from './userEligibilityForm'

export default function index() {
  return (
    <div className='h-lvh w-full flex justify-center items-center p-6'>
      <UserEligibilityForm />
    </div>
  )
}
